import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-learning-center',
  templateUrl: './learning-center.component.html',
  styleUrls: ['./learning-center.component.css']
})
export class LearningCenterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
